const getOrigins = (browserWindow)=> {
    let url = browserWindow.location.origin;
    url = process.env.REACT_APP_ENV === 'local' ? url.replace(':3000', ':4300') : url;
    return url;
}

export default getOrigins;